import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/home/Home';
import APropos from './components/a-propos/APropos';
import ReservationsAppel from './components/reservationsappel/ReservationsAppel';
// Importez vos nouveaux composants
import DeveloppementWeb from './components/Développement-Web/Développement-Web';
import DeveloppementMobile from './components/Développement-Mobile/Développement-Mobile';
import DesignNumerique from './components/Design-Numérique/Design-Numérique';
import StrategieSEO from './components/Stratégie-SEO/Stratégie-SEO';
import SolutionsEcommerce from './components/Solutions-E-commerce/Solutions-E-commerce';
import RefonteSiteWeb from './components/Refonte-de-Site-Web/Refonte-de-Site-Web';
import MarketingDigital from './components/marketing-digital/MarketingDigital';
import IAEtAutomatisation from './components/IAEtAutomatisation/IAEtAutomatisation';
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reservation-appel" element={<ReservationsAppel />} />
          <Route path="/a-propos" element={<APropos />} />

            {/* Nouvelles routes */}
          <Route path="/developpement-web" element={<DeveloppementWeb />} />
          <Route path="/developpement-mobile" element={<DeveloppementMobile />} />
          <Route path="/design-numerique" element={<DesignNumerique />} />
          <Route path="/strategie-seo" element={<StrategieSEO />} />
          <Route path="/solutions-ecommerce" element={<SolutionsEcommerce />} />
          <Route path="/refonte-site-web" element={<RefonteSiteWeb />} />
          <Route path="/marketing-digital" element={<MarketingDigital />} />
          <Route path="/ia-automatisation" element={<IAEtAutomatisation />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;